import { ShareLinkTypeEnum } from "../../generated/graphql";
import { ShareLinkFormData } from "./modals/ShareLinkFormModalContext";

export const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleDateString("uk-UA") : "—";

// expiresAt -> value for <input type="date"> (yyyy-MM-dd)
export const toDateInputValue = (value?: string | null) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().slice(0, 10);
};

export const isValidHttpUrl = (value?: string | null) =>
  /^https?:\/\/.+/i.test((value || "").trim());

// By type: CONTENT requires targetUlcId, EXTERNAL_URL requires a valid http(s) URL.
export const validateShareLink = (data: ShareLinkFormData) => {
  if (data.type === ShareLinkTypeEnum.ExternalUrl) {
    return isValidHttpUrl(data.externalUrl);
  }
  return !!data.targetUlcId;
};
